<template>
    <div>
<!--    <label class="c-tip" onclick="window.location='/tabs/certification'">-->
<!--        <el-alert style="background-color: #f54848;color: #F5E4CB;"  title="温馨提示：应公安部要求，请进行实名认证，如发现违反法律法规（包括但不限于诈骗、色情、博彩等），则立即封禁相关账号" type="warning" show-icon :closable="false"></el-alert>-->
<!--    </label>-->
        <div class="trans-tip" v-if="userInfo.ustate==0">
            <label class="c-tip"  @click="$router.push('/tabs/flowRecharge')">
                <el-alert style="background: #c30;color:#fff;"  title="重要提醒：因业务风险，您无法使用我司普通域名转换，被限制只能使用专属域名（备注安全）+自有域名，详细咨询客服" type="warning" show-icon :closable="false"></el-alert>
            </label>
        </div>
    <div class="index-box">




        <div class="index-title">转换短网址
          <router-link to="/tabs/renling" style="color:#999;font-size:14px;float:right;">认领二维码/短网址 (自己在游客转换时候的二维码/短链接)</router-link>
        </div>


        <div style="color:#f76a1a;font-size: 12px;background: #f5f5f5;padding:10px 10px; text-align: left;margin:20px 0 50px 0;font-size: 16px;display: none;" >限时活动，购买访问包送一年VIP<br>
            <div style="font-size: 12px;color:#999;">
                问题Q：为什么还需要购买访问包？<br>
                解释： 访问包是访问的消耗，访问量越大，我们服务器成本越高，所以需要单独购买。<br>
                问题Q：如果没有访问包，会怎么样？<br>
                解释： 如果没有访问包，系统可能会跳转到广告。<br>
            </div>
        </div>

        <el-form :model="ruleForm" status-icon :rules="rules" ref="urlForm" label-width="100px">
            <div style="margin-left:100px;font-size:12px;padding:10px 0;color:red;" @click="$router.push('/tabs/buyDomain')">受到别的用户影响，共享域名容易失效，请尽量使用专属域名或自有域名转换</div>
            <el-form-item label="长网址：" prop="url">
                <el-input v-model="ruleForm.url" clearable @clear="urlClear" @input="urlInput"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button class="btn-box" type="primary" @click="submitForm">获取短网址</el-button>
            </el-form-item>
            <el-form-item>
                <el-button class="btn-box" type="success" plain @click="batchConversion">批量转换</el-button>
            </el-form-item>
          <el-form-item>
            <el-button class="btn-box" type="success" plain @click="$router.push('/tabs/exclusiveShort')">专属域名转换点击这里</el-button>

          </el-form-item>
        </el-form>
        <div class="result-box" v-show="isShowResult">
            <div class="top-ico">
                <i class="el-icon-success"></i>
                <span>转换成功</span>
            </div>
            <div class="item">
                <div class="l">短网址：</div>
                <div class="m">
                    <el-input v-model="shortUrl" readonly></el-input>
                </div>
                <div class="r">
                    <el-button type="primary" @click="copyUrl">点我复制</el-button>
                </div>
            </div>
          <div class="item">
              <div style="padding:15px 20px;margin-left:120px;margin-top:20px;background:#c30;border-radius: 40px;border-top-left-radius: 0px;line-height:200%;display:inline-block; ">
                  <router-link to="/tabs/buyDomain" style="color:#fff;font-weight: bolder">请使用专属域名，共享域名容易被其他用户违规导致所有失效！ </router-link>
              </div>
          </div>
            <div class="item">
                <div class="lab">二维码：</div>
                <div class="qrCode" ref="qrCodeDiv"></div>
                <div class="dl-btn">
                    <el-button type="primary" plain @click="savePic">下载二维码</el-button>
                </div>
            </div>
<!--            <div class="item">-->
<!--                <div><router-link to="/tabs/flowRecharge" style="color:red;background:#f6d8d8;color:red;font-weight: bold;display: block;padding: 5px 10px;text-align: center;">购买任意访问包赠送一年VIP，享受以下20+项权益，点击查看</router-link></div>-->
<!--                <div style="text-align:center;color: #ccc;padding: 10px;font-size: 14px;">因服务器维护成本高，请购买访问包，否则会有广告和提示到期</div>-->
<!--            </div>-->
        </div>
        <div class="about-box">
            <div class="index-title2">天天短网址的优势-数据统计</div>
            <div class="about-s"><div class="about-s-main"><i style="color:green;" class="iconfont icon-dwzzhexiantu"></i> <b>访问量统计</b> <p>可以精准统计链接的IP，UV,PV 等</p></div>  </div>
            <div class="about-s"><div class="about-s-main"><i style="color:#a64ec6;" class="iconfont icon-dwzshuju"></i> <b>地域统计</b> <p>一目了然统计链接访问的地图省份地域</p></div>  </div>
            <div class="about-s"><div class="about-s-main"><i style="color:#0B5E6D;" class="iconfont icon-dwzliebiao"></i> <b>客户端统计</b> <p>phone,安卓,mac ,windows等</p> </div> </div>
            <div class="about-s"><div class="about-s-main"><i style="color:#6ea7d0;" class="iconfont icon-dwzbianji"></i> <b>浏览器统计</b> <p>chrome,QQ浏览器，uc浏览器，微博客户端等</p></div>  </div>
            <div class="about-s"><div class="about-s-main"><i style="color:#0000ff;" class="iconfont icon-dwzchart-pie"></i> <b>运营商统计i</b> <p>统计网络电信运营商，如移动联通电信长城等</p></div>  </div>
            <div class="about-s"><div class="about-s-main"><i style="color:#0b9108;" class="iconfont icon-dwzliebiao"></i> <b>高频IP统计</b> <p>统计列出top前10访问量最大的IP地址</p></div>  </div>
            <div class="about-s"><div class="about-s-main"><i style="color:#d81e06;" class="iconfont icon-dwzmenu"></i> <b>访问记录明细</b> <p>所有访问记录呈现并永久保存到云端</p> </div> </div>
            <div class="about-s"><div class="about-s-main"><i style="color:#491217;" class="iconfont icon-dwzzhexiantu"></i> <b>图标显示统计数据</b> <p>chrome,QQ浏览器，uc浏览器，微博客户端等</p></div>  </div>
            <div class="clear"></div>
            <div class="index-title2">天天短网址的优势-高级功能</div>
            <div class="about-s"><div class="about-s-main"><i style="color:#1c6a9e;" class="iconfont icon-dwzRectangleCopy38"></i> <b>单次批量转换</b> <p>一次可以批量转换几十条甚至上百条 </p></div>  </div>
            <div class="about-s"><div class="about-s-main"><i style="color:#6ea7d0;" class="iconfont icon-dwzRectangleCopy31"></i> <b>数量限制</b> <p>可转换的数量远高于同行</p></div>  </div>
            <div class="about-s"><div class="about-s-main"><i style="color:#491217;" class="iconfont icon-dwzRectangleCopy33"></i> <b>多链接随机</b> <p>可多条链接随机设定和展示</p> </div> </div>
            <div class="about-s"><div class="about-s-main"><i style="color:#4eccc4;" class="iconfont icon-dwzelectronics"></i> <b>智能策略-PC识别</b> <p>可设定电脑和手机打开不一样的链接</p></div>  </div>
            <div class="about-s"><div class="about-s-main"><i style="color:#0F3A56;" class="iconfont icon-dwzRectangleCopy18"></i> <b>智能策略-移动设备识别</b> <p>可根据不同设备设定不一样的落地链接</p></div>  </div>
            <div class="about-s"><div class="about-s-main"><i style="color:#0A246A;" class="iconfont icon-dwzRectangleCopy34"></i> <b>智能策略-地理位置策略</b> <p>可根据地理位置设定不同的链接</p></div>  </div>
            <div class="about-s"><div class="about-s-main"><i style="color:#1AAD19;" class="iconfont icon-dwzcolumn-horizontal"></i> <b>智能策略-微信浏览器识别</b> <p>可在微信浏览器识别，并自定义访问</p> </div> </div>
            <div class="about-s"><div class="about-s-main"><i style="color:#00a249;" class="iconfont icon-dwzRectangleCopy40"></i> <b>管理短网址</b> <p>可修改删除随时管理短链接</p></div>  </div>
            <div class="about-s"><div class="about-s-main"><i style="color:#daa726;" class="iconfont icon-dwzRectangleCopy36"></i> <b>设置短网址访问密码</b> <p>可设置用户访问查看的密码</p></div>  </div>
            <div class="about-s"><div class="about-s-main"><i style="color:#BD362F;" class="iconfont icon-dwzexport"></i> <b>修改短网址指向</b> <p>随时可自由修改源链接</p> </div> </div>
            <div class="about-s"><div class="about-s-main"><i style="color:#00b800;" class="iconfont icon-dwzRectangleCopy38"></i> <b>高级功能-不同地区指向网址</b> <p>可根据不同区域设定不一样的落地链接</p></div>  </div>
            <div class="about-s"><div class="about-s-main"><i style="color:#514721;" class="iconfont icon-dwzRectangleCopy10"></i> <b>高级功能-不同设备指向网址</b> <p>可根据不同设备设定不一样的落地链接</p></div>  </div>
            <div class="about-s"><div class="about-s-main"><i style="color:#BD362F;" class="iconfont icon-dwzRectangleCopy"></i> <b>高级功能-提示浏览器打开</b> <p>可根据不同浏览器设定不一样的落地链接</p></div>  </div>
            <div class="about-s"><div class="about-s-main"><i style="color:#0C5F9B;" class="iconfont icon-dwzcode"></i> <b>API接口转换</b> <p>可使用API接口批量转换</p></div>  </div>
            <div class="clear"></div>

        </div>
    </div>
    </div>

</template>

<script>
    import QRCode from 'qrcodejs2';
    export default {
        name: "Index",
        data() {
            const validateUrl = (rule, value, callback) => {
                const isUrl = this.$common.isUrl(value);
                if (value === '') {
                    callback(new Error('请输入要转换的长链接'));
                }else if (!isUrl){
                    callback(new Error('请输入正确的长链接'));
                } else {
                    callback();
                }
            };
            return {
                ruleForm: {
                    url: '',
                },
                rules: {
                    url: [
                        { validator: validateUrl, trigger: 'blur' }
                    ],
                },
                shortId: 0,
                shortUrl: "123456789",
                isShowResult: false,
                userInfo:{},
            }
        },
        mounted() {
            var $this=this;
            this.userInfo=this.$common.userInfo;
            setTimeout(function(){
                $this.userInfo=$this.$common.userInfo;
            },1000)
        },
        methods: {
            submitForm() {
                this.$refs.urlForm.validate((valid) => {
                    if (valid) {
                        this.zh();
                    }
                });
            },
            async zh() {
                const postData = {
                    url: this.ruleForm.url,
                };
                const {ret,data} = await this.$api.shortUrl.zh(postData);
                if (ret === 1000){
                    this.$message.success("转换成功");
                    this.shortId = data.id;
                    this.shortUrl = data.url;
                    this.isShowResult = true;
                    this.bindQRCode();
                }
            },
            urlClear() {
                this.shortId = "";
                this.shortUrl = "";
                this.isShowResult = false;
                this.$refs.qrCodeDiv.innerHTML = '';
            },
            urlInput(val) {
                if (val === ''){
                    this.shortId = "";
                    this.shortUrl = "";
                    this.isShowResult = false;
                    this.$refs.qrCodeDiv.innerHTML = '';
                }
            },
            batchConversion() {
                this.$router.push('/tabs/batchConversion');
            },
            bindQRCode() {
                const txt = this.shortUrl;
                if (txt === '') return;
                this.$refs.qrCodeDiv.innerHTML = '';
                new QRCode(this.$refs.qrCodeDiv, {
                    text: txt,
                    width: 200,
                    height: 200,
                    colorDark: "#333333", //二维码颜色
                    colorLight: "#ffffff", //二维码背景色
                    correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
                });
            },
            savePic() {
                let myQrCode = this.$refs.qrCodeDiv.getElementsByTagName('canvas');
                let a = document.createElement('a');
                a.href = myQrCode[0].toDataURL('image/png');
                a.download = this.shortUrl;
                a.click();
            },
            copyUrl() {
                const msg = this.$message;
                if (this.shortUrl === ''){
                    msg.error('复制的内容为空！');
                    return;
                }
                this.$copyText(this.shortUrl).then(function (e) {
                    msg.success('复制成功');
                }, function (e) {
                    msg.error('复制失败！');
                });
            }
        },
    }
</script>

<style scoped>
    .index-box{
        width: 940px;
        height: auto;
        margin-left: 80px;
        padding: 30px 120px 30px 40px;
    }
    .index-box .index-title{
        width: 100%;
        height: 28px;
        font-size: 20px;
        margin-bottom: 40px;
    }
    .index-box .btn-box{
        width: 100%;
    }
    .result-box{
        width: 100%;
        height: auto;
        padding-top: 40px;
    }
    .result-box .top-ico{
        width: 840px;
        height: 40px;
        color: #07cc00;
        font-size: 24px;
        text-align: center;
        line-height: 40px;
        margin-left: 100px;
        margin-bottom: 20px;
    }
    .result-box .top-ico i{
        display: inline-block;
        font-size: 40px;
        margin-right: 10px;
        vertical-align: top;
    }
    .result-box .item{
        width: 100%;
        height: auto;
        padding-bottom: 20px;
    }
    .result-box .item .l{
        display: inline-block;
        width: 100px;
        height: 40px;
        color: #606266;
        font-size: 14px;
        text-align: right;
        line-height: 40px;
        padding-right: 12px;
        vertical-align: top;
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }
    .result-box .item .m{
        display: inline-block;
        width: 720px;
        height: 40px;
        vertical-align: top;
    }
    .result-box .item .r{
        display: inline-block;
        width: 98px;
        height: 40px;
        margin-left: 22px;
        vertical-align: top;
    }
    .result-box .item .lab{
        display: inline-block;
        width: 100px;
        color: #606266;
        font-size: 14px;
        text-align: right;
        line-height: 40px;
        padding-right: 12px;
        vertical-align: top;
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }
    .result-box .item .qrCode{
        display: inline-block;
        width: 200px;
        height: 200px;
        vertical-align: top;
    }
    .result-box .item .dl-btn{
        display: inline-block;
        width: 112px;
        height: 120px;
        margin-left: 40px;
        padding-top: 80px;
        vertical-align: top;
    }

    .clear{clear: both;}

    .about-box{margin-top: 50px;}
    .about-box .index-title2{padding: 0px 0px;font-size: 18px;color:#6ea7d0;margin-top:20px;}
    .about-box .about-s{width:220px;margin-right:10px;float:left;background:#f4f7f369;height:90px;margin-top: 10px;}
    .about-box .about-s .about-s-main{padding:15px;}
    .about-box .title2{font-weight: bold;padding:20px 0;}
    .about-box .about-s b{font-size:14px;font-weight: bold;color:#727888;}
    .about-box i{font-size:20px;   }
    .about-box p{font-size: 14px;color: #727888;}
</style>
